'use client';

import Plausible from 'plausible-tracker';

export const PLAUSIBLE_EVENTS = {
    seoLoginPopupOpened: "lg_pu_open",
    seoNextArticlePopupTap: "st_nxart_cl",
    seoEmailLoginAttempt: "st_emlg_st",
    seoTelegramLoginAttempt: "st_tglg_st",
    seoPostCTAButtonTap: "st_pctabt",
};

declare global {
    interface Window {
        // Cache to keep registered events to prevent duplicates
        chatlanga_plev: Record<string, boolean>;
    }
}

export function trackPlausibleEvent({name, url = null, domain = null, onlyOnce = false}: {name: string, url?: string | null, domain?: string | null, onlyOnce?: boolean}) {
    // // We only do this type of logging in production
    if (process.env.NODE_ENV != "production") {
        return;
    }

    try {
        if (domain == null)
            domain = "chatlangta.app"

        if (url != null && url.indexOf("//") == -1) {
            url = "https://chatlangta.app" + url
        } else if (url == null) {
            url = (typeof window !== "undefined" && window.location.href.split("?")[0]) || null;
        }

        if (url == null) {
            console.warn("event error: url is null");
            return;
        }

        if (name == null) {
            name = "unknown"
        }

        if (onlyOnce) {
            if (typeof window !== "undefined") {
                window.chatlanga_plev = window.chatlanga_plev || {};
                if (window.chatlanga_plev[name] != null) {
                    return;
                }
                window.chatlanga_plev[name] = true;
            }
        }

        const { trackEvent } = Plausible();

        trackEvent(name, { props: { url } });              
    } catch(e) {
        // Fail silently
    }
}